import { render } from "./ApproveWallet.vue?vue&type=template&id=313a0316&scoped=true"
import script from "./ApproveWallet.vue?vue&type=script&lang=js"
export * from "./ApproveWallet.vue?vue&type=script&lang=js"

import "./ApproveWallet.vue?vue&type=style&index=0&id=313a0316&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313a0316"]])

export default __exports__